import React from 'react';
import {Link as NewLinl, withRouter} from 'react-router-dom';
import Scroll from 'react-scroll';
import {ONLINE_WORKSHOPS} from 'stores/WorkshopsUrlConstants';
import {inject} from 'mobx-react';
import './styles.css';

const Link   = Scroll.Link;
const Element = Scroll.Element;
const CPDWorkshopsElement = 'CPDWorkshopsElement';
const GroupSupervisionElement = 'GroupSupervisionElement';
const OrganizationLearningElement = 'OrganizationLearningElement';

@withRouter
@inject('user')
export default class OurServices extends React.Component {
  redirectToOnline = (id) => {
    this.props.history.push('/details/online/' + id)
  };

  redirectToRegular = (id) => {
    this.props.history.push('/details/regular/' + id)
  };

  redirectWebinar = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/webinars');
    } else {
      this.props.history.replace('/online_workshops', {webinar: true});
    }
  };

  redirectOnline = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/online');
    } else {
      this.props.history.replace('/online_workshops', {online: true});
    }
  }

  redirectGroup = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/group_supervision');
    } else {
      this.props.history.replace('/online_workshops', {group: true});
    }
  }

  redirectOrg = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/group_supervision');
    } else {
      this.props.history.replace('/online_workshops', {organizations: true});
    }
  }

  redirectToRegular = () => {
      this.props.history.push('/regular_workshops');
  };

  render(){
    return(
      <main className="main-content">
        <section className="invest">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <div className="invest-inner">
                  <div className="invest-holder">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                      <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                            className="st0"/>
                      <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                            className="st0"/>
                      <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                            className="st1"/>
                      <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                            className="st2"/>
                      <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                            className="st3"/>
                      <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                      <path d="M132.6 421h521" className="st5"/>
                      <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                            className="st6"/>
                      <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                            className="st7"/>
                      <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                            className="st8"/>
                      <circle cx="393.1" cy="321" r="24" className="st9"/>
                      <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                            className="st10"/>
                      <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                            className="st11"/>
                      <g>
                        <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                      </g>
                      <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                            className="st11"/>
                    </svg>
                    <div className="shadow"/>
                  </div>
                  <p className="invest-slogan">OUR SERVICES</p>
                  <ul className="invest-professions">
                    <li>Therapy Academy provides a variety of online learning options.</li>
                  </ul>
                  {/* <div className="invest-btn-holder">
                    <Link to={CPDWorkshopsElement} className="add-workshop">CPD Workshops</Link>
                    <Link to={GroupSupervisionElement} className="add-workshop">Group Supervision</Link>
                    <Link to={OrganizationLearningElement} className="add-workshop">Organisational Learning </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
        <Element className="os_cpdworkshops_container" name={CPDWorkshopsElement}>
          <div className="container-fluid">
            <div className="os_cpdworkshops">
              <p className="invest-slogan">CPD WORKSHOPS</p>
              <p className="os-cpd-text">Continue your professional development online with a range of online workshops, courses and interactive webinars provided by accredited therapists who are experts in their field. Build your CPD hours online today.</p>
            </div>
            <div className="os-online-workshops">
              <div className="os-online-wrapper">
                <p className="invest-slogan os-list-title">Online Workshops</p>
                <ul className="os-online-list">
                  <li className="os-online-item">Available 24/7. Learn at your own pace, in your own time</li>
                  <li className="os-online-item">Workshops consist of modules with a quiz at the end of each module</li>
                  <li className="os-online-item">Modules can contain text based content, images, video content, video presentations, articles or research documents</li>
                  <li className="os-online-item">CPD certs automatically generated on successful completion of workshop & accompanying quizzes</li>
                </ul>
                <p onClick={this.redirectOnline} className="os-link">Find a list of online workshops here</p>
              </div>
            </div>
            <div className="os-live-workshops">
              <div className="os-online-wrapper">
                <p className="invest-slogan os-list-title">Live Webinars</p>
                <ul className="os-online-list">
                  <li className="os-online-item">Live workshops with the ability to interact with the provider via online chat or via video and audio</li>
                  <li className="os-online-item">CPD certs automatically generated on successful completion of webinar & accompanying quiz</li>
                </ul>
                <p onClick={this.redirectWebinar} className="os-link">Find a list of live webinars here</p>
                <br />
                <span style={{textAlign: 'left'}}>
                  Does your organisation facilitate CPD training for you? At Therapy Academy we provide free access to our online workshops and webinars and bill your employer or organisation directly. We can arrange for individual or group training on all manner of topics.
                  <br />
                  <a href='mailto:support@therapyacademy.ie'>Please email support@therapyacademy.ie for more information.</a>
                </span>
              </div>
            </div>
            <div className="os-online-workshops">
              <div className="os-online-wrapper">
                <p className="invest-slogan os-list-title">Regular Workshops</p>
                <ul className="os-online-list">
                  <li className="os-online-item">In person workshops at various locations around the country </li>
                  <li className="os-online-item">Book through Therapy Academy and receive your CPD cert automatically on your TA dashboard after attending</li>
                  <li className="os-online-item os-link"  onClick={this.redirectToRegular}>Find a list of regular workshops here</li>
                  <li className="os-online-item">Does your organisation deliver 'Regular In-Person Workshops'? List them on Therapy Academy for free. Email <a href='mailto:support@therapyacademy.ie'>support@therapyacademy.ie</a> for more details </li>
                </ul>
              </div>
            </div>
          </div>
        </Element>

        <Element className="main-workshops dark-background" name={GroupSupervisionElement}>
          <div className="container-fluid">
            <div className="os_cpdworkshops os-group">
              <p className="invest-slogan">PUBLIC WEBINARS & WORKSHOPS</p>
              {/* <p className="invest-slogan os-group-supervision-slogan">Why choose online Group Supervision?</p> */}
              <p className="organization-text">Public Webinars & Workshops developed by mental health experts.</p>
              <div className="os-group-supervision-lists-wrapper">
                <ul className="os-group-supervision-list">
                  <li className="os-group-supervision-list-item">Partake in interactive Live Webinars</li>
                  <li className="os-group-supervision-list-item">Access high quality Workshops at a time and place that suits you</li>
                  <li className="os-group-supervision-list-item">Exposure to a broad range of mental health topics</li>
                </ul>
                <ul className="os-group-supervision-list">
                  <li className="os-group-supervision-list-item">Choose specific Workshops that meet your needs</li>
                  <li className="os-group-supervision-list-item">Benefit from group learning and engagement; observational learning, modeling and rehearsing positive and productive discussion</li>
                </ul>
              </div>
              <p onClick={this.redirectGroup} className="os-link os-centered-link">Find available Public Webinars & Workshops sessions here</p>
            </div>
          </div>
        </Element>

        <Element className="maios_cpdworkshops_container" name={OrganizationLearningElement}>
          <div className="container-fluid">
            <div className="os_cpdworkshops os-group">
              <p className="invest-slogan">ORGANISATIONAL LEARNING</p>
              <p className="os-cpd-text">Does your organisation facilitate CPD training for you? At Therapy Academy we provide free access to our online workshops and webinars and bill your employer or organisation directly. We can arrange for individual or group training on all manner of topics.</p>
              <a href='mailto:support@therapyacademy.ie' className="os-link os-centered-link">Please email support@therapyacademy.ie for more information.</a>
            </div>
          </div>
        </Element>

      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/informations/ourServices/index.jsx